module.exports = __webpack_public_path__ + "static/media/nami.ee048d72.svg";